"use strict";
import PersonDetection from "../../widgets/personDetection.js";
import './stat-person.less';

App.Pages.StatPerson = class StatPerson extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true
			},
			path: '/stat-person',
			nameRu: 'Детекции по человеку',
		};
	}


	static get template()
	{
		//language=HTML
		return `
			<div class="page navbar-fixed">
				<div class="page-content ptr-content" pf="pageContent">

					<div class="page-header">
						<a href="#" onclick="history.back();" class="breadcrumb link" pf="linkBack"><i class="icon material-icons">chevron_left</i>Вернуться назад</a>
						<h3>Детекции по человеку</h3>
					</div>

					<div class="person-block" pf="personBlock"></div>
					
					<form class="filterForm" pf="form">
						<div pf="elements"></div>
						<div class="row resizable">
							<div class="col-65">
								<div pf="preset"></div>
							</div>
							<div class="col-15">
								<input pf="dates"/>
							</div>
							<div class="col-20">
								<input pf="similarity"/>								
							</div>
						</div>
					</form>

					<div class="card" pf="list" style="padding:0"></div>
				</div>

			</div>

		`;
	}

	get contentTemaplate()
	{
		//language=HTML
		return `
			<div class="person-block card">
				<div class="person-data">
					<div class="img">
						<img src="@{model.personImgs.0.file.local_url}" pf="img">
					</div>
					<div class="info">
                    	Персональный ид: <span>@{model.id}</span>  <br/>
						@{model.similarityDiv}
						Возраст: <span>@{model.age}</span><br/>
						Пол: <span>@{model.gender.name}</span><br/>
					</div>
					@{model.rawPerson}
				</div>
			</div>
		`;
	}


	init()
	{
		super.init();

		this.id = app.pageParams.id;
		// if (app.router.currentRoute.query.id != undefined) {
		// 	this.id = app.router.currentRoute.query.id;
		// 	console.log(app.router.currentRoute.query.id);
		// }

		this.return = app.pageParams.return;

		// this.dom.linkBack.on("click", () =>
		// {
		// 	if (this.return == 'detections')
		// 	{
		// 		app.router.navigate('/detections');
		// 	}
		// });

		this.model = new PF.Model({
			represent: "person/View",
			saveOnModify: false,
			where: `id ='${this.id}'`
		});

        this.model.maxQualityPercent = "0%";
        this.model.similarityDiv = ``;
        this.model.rawPerson = null;
        this.model.onValue('options.loadStatus', 'loaded', () =>
        {
            this.model.maxQualityPercent = (this.model.max_quality * 100).toFixed(2) + "%";

            if (this.model.similarity_id)
            {
                // this.model.similarityDiv = `Персональный индекс: ${this.model.similarity_id} <br/>`;
            } else if (this.model.get('description.similarity_id', null, null) !== null && this.model.get('raw_person', null, null) !== null)
            {
                let maxQualityPercent = (this.model.description.similarity * 100).toFixed(2) + "%";
                this.model.similarityDiv = `С вероятностью ${maxQualityPercent}, это персона с ид:<br/>${this.model.raw_person.id}`;
				// <a href="/stat-person?id=${this.model.raw_person.id}" class="" >${this.model.raw_person.id}</a>`;

                if (this.model.raw_person.personImgs.count > 0)
                {
                    this.model.similarityDiv += ` →<br/>`;
                    this.model.rawPerson = `<div class="img"><img src="${this.model.raw_person.personImgs[0].file.local_url}"></div>`;
                } else
                {
                    this.model.similarityDiv += `<br/>`;
                }
            }
        });

		this.dom.load(this.contentTemaplate, 'content')
		this.dom.content.bindObject(this)
		this.dom.personBlock.append(this.dom.content)

		//-------    
		this.statFilters = new PF.Model({ represent: "user-data/stat-filters-persons", saveOnModify: true, raw: { data: {} } });
		this.statFiltersDetection = new PF.Model({ represent: "user-data/stat-filters-persons-detection", saveOnModify: true, raw: { data: {} } });


		this.flag = false;

		this.statFiltersDetection.onValue('options.loadStatus', 'loaded', () =>
		{
			this.statFilters.onValue('options.loadStatus', 'loaded', () =>
			{
                let similarity = this.statFilters.data.similarity;
                if (app.pageParams.similarity && app.pageParams.similarity * 100 < similarity)
                {
                    similarity = app.pageParams.similarity * 100 - 1;
                    similarity = similarity.toFixed(0);
                }
                this.statFiltersDetection.data.calendar = this.statFilters.data.calendar;
                this.statFiltersDetection.data.diapasonPreset = this.statFilters.data.diapasonPreset;
                this.statFiltersDetection.data.stellas = this.statFilters.data.stellas;
				this.statFiltersDetection.data.similarity = similarity;
				this.statFiltersDetection.options.dicts = this.statFilters.options.dicts;
				this.statFiltersDetection.save();

				this.statFiltersInit();
			});

		});

		this.statFiltersDetection.on('save-success', () =>
		{
			if (this.flag == true)
			{
				this.list.models.reload();
				this.list.calc("title", "models.count", (count) => isFinite(count) ? `Найдено ${count} ${Util.spell(count, ['', 'детекция', 'детекции', 'детекций'])}` : ``);
			}
		}, true);



	} // init

	statFiltersInit() 
	{
		this.form = new PF.Form({
			dom: { element: this.dom.form },
			model: this.statFiltersDetection,
			keyPrefix: 'data.',
			toastOnSave: false,
			fieldsConfig: {
				elements: {
					class: PF.Field.TreeMultiSelect,
					label: 'Выберете стелу:',
					includeRoot: false,
					types: {
						root: {
							model: new PF.Model({
								raw: {
									districts: this.statFiltersDetection.options.dicts.districts
								}
							}),
							childsKey: 'districts',
						},
						district: {
							childsKey: 'stellas',
							itemClass: ListDistrict
						},
						stella: {
							selectable: true,
							key: 'data.stellas',
							modelsConfig: {
								deletePolicy: 'delete'
							},
						},
					},
					simpleTitle: (count) =>
					{
						Util.sleep(2).then(() =>
						{
							if (count < 5 && count > 0)
							{
								let stellas = this.statFiltersDetection.data.stellas;
								let t = Util.spell(count, ['', 'Выбрана:', 'Выбраны:', 'Выбраны:']);
								for (let i = 0; i < stellas.size; i++)
								{
									if (i === 0)
									{
										t += ` "${stellas[i].name}"`;
									} else
									{
										t += `, "${stellas[i].name}"`;
									}
								}
								this.statFiltersDetection.options.form.fields.elements.simpleTitleText = t;
							}
						});
						return `Выбрано ${Util.spell(count, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`;
					},
				},
				dateDiapason: {
					class: PF.Field.DateDiapasonWithPreset,
					presetConfig: {
						dom: {
							element: this.dom.preset
						},
						key: 'data.diapasonPreset',
					},
					datesConfig: {
						dom: {
							element: this.dom.dates
						},
						startKey: 'data.calendar.start',
						finishKey: 'data.calendar.finish',
					},
				},
				similarity: {
					class: PF.Field.Float,
					label: 'Совпадение от(%)',
					minValue: 0,
					maxValue: 100,
				}
			}
		});


		this.flag = true;

		this.initList();

	} // statFiltersInit

	initList()
	{
		this.list = new PF.List({
			dom: {
				element: this.dom.list,
				scrollTarget: this.dom.list,
				rendererTitle: this.rendererTitle,
			},
			searchable: false,
			modelsConfig: {
				represent: 'detection/ViewAllPerson',
				limit: 10,
				where: `person_id ='${this.id}'`
			},
			listTitle: true,
			itemClass: PersonDetection,
		});

		// this.dom.load(this.rendererTitle, 'rendererTitle');
		// this.list.dom.ul.prepend(this.dom.rendererTitle);
	} // initList

	get rendererTitle()
	{
		//language=HTML
		return `
    		<div pf="item">
                <div class="item-content">
                    <div class="item-inner">
                        <table class="detection-table" style="color: #8190AF;">
                            <tr>
                                <td class="similarity"> 
                                    <span >Совпадение</span> 
                                </td>
                                <td class="img">
                                    <span >Фото</span> 
                                </td>
                                <td class="time"> <span class="span"> Время </span> </td>
                                <td class="server-va"> <span class="span"> Стела </span> </td>
                                <td class="camera"> <span class="span"> Камера </span> </td>
                                <td class="emotion"> <span class="span"> Эмоция </span> </td>
                                <td class="has-screen"> <span class="span"> Просмотр </span> </td>
                                <td class="process"> <span class="span"> Статус </span> </td>
                            </tr>     
                        </table>
                    </div>
    			</div>
    		</div>
    	`;
	}
}

class ListDistrict extends PF.Field.TreeMultiSelect.Item
{
	static get options()
	{
		return {
			title: `@{model.name}`,
			formConfig: {
				notModifyBehavior: 'hide',
				fieldsConfig: {
					name: {
						class: PF.Field.String,
						label: 'name',
					}
				}
			}
		};
	}

	get itemInner()
	{
		//language=HTML 
		return `
				<div class="item-inner">
					<div class="item-title">
						@{model.name}<br/>
					</div>
					<div class="item-after">
						Количество стел: @{model.stellas.count}
					</div>
				</div>`;
	}
}